import { useMasterDataProducts } from "@src/presentation/providers/MasterDataProductsDataProvider";
import { MasterDataListFooter } from "./MasterDataListFooter";

export const MasterDataProductsFooter = () => {
  const { total, page, limit, loading, setPage } = useMasterDataProducts();

  return (
    <MasterDataListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="Products Pagination"
    />
  );
};
